import React from 'react';
import {
  Form, Row, Col, Input, Select, Button, Icon
} from 'antd';
import img from './../../assets/img/Illustration.png';
const { Option } = Select;
class FD extends React.Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      this.props.submitHandler({ ...values, id: 0 }, (val) => {
        if (!val) {

        }
      });
    });
  }


  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18} >
            <p style={{ marginLeft: "14px" }} className='mi_title'>Add</p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>

          <Row span={24}>
            <Col sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Participants</legend>
                  {getFieldDecorator('participants', {
                    rules: [{ required: true, message: 'Please select Participants.' }],
                  })(<Select
                    suffixIcon={<Icon type="search" />}
                    className="mi_input"
                    optionFilterProp="children"
                    mode='multiple'
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    // onChange={this.GetStatebyLoAState}
                    placeholder="Search"
                  >
                    {this.props.participants
                      ? this.props.participants.map((tag) => (
                        <Option value={tag.userId} key={tag.name}>
                          {tag.name}
                        </Option>
                      ))
                      : ""}
                  </Select>)}
                </fieldset>
              </Form.Item>
              </Col></Row>
          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7} ></Col>
            <Col span={5} >
              <Button className="mi_button_right submit-button" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Cancel
              </Button>
            </Col>
            <Col span={5} >
              <Button htmlType="submit" className="submit-button" type="primary" >
                Add
              </Button>
            </Col>
            <Col span={7} >
              <img alt="example" style={{ width: 105, marginBottom: '-28px', float: 'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const AddparticipantsDrawer = Form.create()(FD);
export default AddparticipantsDrawer;